import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  downloadContainer: {
    position: 'relative',
    paddingTop: 60,
    minHeight: 500,
    [theme.breakpoints.down('md')]: {
      padding: '60px 0'
    }
  },
  featuredImageContainer: {
    // display: 'none',
    position: 'absolute',
    bottom: '0px',
    right: 0,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      position: 'static',
      marginTop: '10px',
      bottom: 'unset',
      right: 'unset',
      justifyContent: 'center',
    }
  },

  downloadButtonContainer: {
    marginLeft: 10,
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      marginLeft: 0,
    }
  },

  textButtonContainer: {
    marginLeft: 10,
    [theme.breakpoints.down('md')]: {
      marginLeft: '-4px',
    }
  },

  limitedWidth: {
    maxWidth: 1024
  },
  phone: {
    width: '120%',
    marginLeft: '-10%'
  },
  subtitleText: {
    color: '#9f9f9f'
  },
  textMe: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%',
      height: '53px',
    }
  },
})

export default makeStyles(styles)
